import React from "react";
import { motion } from "framer-motion";

const events = [
  { year: "2003", t: "Início do primeiro mandato presidencial de Lula." },
  { year: "2005", t: "Revelações e crise política relacionada ao Mensalão." },
  { year: "2011", t: "Início do governo Dilma Rousseff." },
  { year: "2014", t: "Início da Operação Lava Jato." },
  { year: "2016", t: "Impeachment de Dilma Rousseff." },
  { year: "2017", t: "Desdobramentos judiciais relacionados ao caso do Triplex do Guarujá." },
  { year: "2018", t: "Prisão de Lula após decisões judiciais relacionadas ao caso." },
  { year: "2019", t: "Novos acontecimentos relacionados à situação jurídica de Lula." },
  { year: "2021", t: "Decisões do STF que alteraram a situação jurídica dos processos." },
];

export default function Timeline() {
  return (
    <section id="timeline" className="relative bg-[#070707] py-24 md:py-36 border-t border-white/5 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Presidente · Prisão · Desdobramentos</span>
          </div>
          <h2 className="font-display font-black text-neutral-50 leading-[0.95] tracking-[-0.02em] text-4xl md:text-6xl">
            Dezoito anos em{" "}
            <span className="text-red-600 italic">uma única linha</span>.
          </h2>
          <p className="mt-6 text-neutral-500 text-sm md:text-base max-w-xl leading-relaxed">
            Use a linha do tempo apenas como resumo histórico. O ebook sempre diferencia fatos
            documentados, acusações e decisões judiciais.
          </p>
        </div>
      </div>

      <div className="relative">
        <div className="rail relative h-[2px] mx-5 md:mx-10 mb-10" />
        <div className="overflow-x-auto scrollbar-none" data-lenis-prevent>
          <div className="flex gap-6 md:gap-10 px-5 md:px-10 min-w-max pb-14">
            {events.map((e, i) => (
              <motion.div
                key={e.year}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="relative w-[240px] md:w-[280px] shrink-0"
              >
                <div className="relative flex items-center justify-center -mt-14 mb-6">
                  <div className="absolute h-3 w-3 rounded-full bg-red-600 red-glow" />
                  <div className="absolute h-10 w-10 rounded-full border border-red-600/40 animate-pulse" />
                </div>
                <div className="border border-white/10 bg-[#0a0a0a] p-6 hover:border-red-600/60 transition-colors">
                  <div className="font-display text-5xl md:text-6xl font-black text-neutral-50 leading-none">
                    {e.year}
                  </div>
                  <div className="h-[1px] w-8 bg-red-600 my-4" />
                  <p className="text-[13px] text-neutral-400 leading-relaxed">{e.t}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
